module.exports = __webpack_public_path__ + "img/email.3ce5bf17.png";